namespace GeniuzPOS.AdvPromo {
    export class PsPromoCampaignColumns {
        static columnsKey = 'AdvPromo.PsPromoCampaign';
    }
}
